import localForage from 'localforage';
export function getStorageEngine() {
    return localForage;
}
